import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function passwordsMatchValidator(newPasswordKey: string, confirmPasswordKey: string): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
        const newPassword = group.get(newPasswordKey)?.value;
        const confirmPassword = group.get(confirmPasswordKey)?.value;
        if (!newPassword || !confirmPassword) {
            return null;
        }
        return newPassword === confirmPassword ? null : {passwordsMismatch: true};
    };
}
